import { Button, Col, Container, Row,  Tabs, Tab, DatePicker } from 'react-materialize';
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import Modal from './modal';
import React from 'react';
import { ErpConnect as qad } from '../../../services/index.js';
import LoadingView from '../loading/loading.view';
import Swal from 'sweetalert2';
import AsyncSelect from 'react-select/async';

class ModalCheckinRep extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      checkinsTotals: {},
      loading: false,
      updateMiliseconds: 1000,
      statuses: [],
      cancelReasons: [],
      checkinDetail: [],
      checkinDetailFiltered: [],
      selectedAgent: null,
      filteredCheckins: [],
      dateSelect: new Date(),
      dateEndSelect: new Date(),
    };
  }

  componentDidMount() {
    this.mountedTimer();
  }

  handleCloseModal = () => {
    this.props.onClose();
    this.setState({
      updateMiliseconds: 1000
    });
    clearInterval(this.timerID);
    this.mountedTimer();
  };

  getSiteForUser = () => {
    const { user } = this.props;

    const spid = String(user?.salesPersonId || '').trim().toUpperCase();
    if (spid === 'VYAM') return '3000';
    if (spid === 'VRAT') return '3100';

    return user?.site || user?.pickup_branch || null;
  };

  async tick() {
    clearInterval(this.timerID);
    try {
   
      const site = this.getSiteForUser();

      const checkinsByStatus = await qad.catalog.website.getCheckinTotals(site);
      let checkinsTotals = {};

      checkinsByStatus.forEach((item) => {
        if (item.status === 'paused' && item.paused_department_id) {
          if (item.paused_department_id === '004') {
            item.main_departament = 'En Caja';
          } else if (item.paused_department_id === '006') {
            item.main_departament = 'En Piso';
          } else if (item.paused_department_id === '007') {
            item.main_departament = 'En Almacén';
          } else {
            item.main_departament = 'Otro Departamento';
          }
        }

        if (!checkinsTotals[item.main_departament]) {
          checkinsTotals[item.main_departament] = {
            main_departament: item.main_departament,
            statuses: []
          };
        }
        checkinsTotals[item.main_departament].statuses.push(item);
      });

      this.setState({
        checkinsTotals,
        loading: false,
        updateMiliseconds: 1000 * 30,
      });

      this.mountedTimer();
    } catch (err) {
      console.error(err);
      this.setState({
        date: new Date(),
        loading: true,
        updateMiliseconds: 1000
      });
      this.mountedTimer();
    }
  }

  clearAgentFilter = () => {

     /*   let count = this.state.checkinDetail.filter(
      item => item.created_by_name === "PAGINA WEB"
    ).length;*/

    this.setState({
      selectedAgent: null,
      filteredCheckins: this.state.checkinDetail,
      createdCount: this.state.checkinDetail.length,
    });
  };

  buildGroupedOrderString = (row) => {
    const primary = String(row.erp_order_id || '').toUpperCase();
    const comment = String(row.comment || row.paused_comment || '').trim();

    if (!comment && !primary) return '';
    const cleaned = comment.replace(/^pedidos[^:]*:/i, '');
    let orders = cleaned
      .split(/[^A-Z0-9]+/i)
      .map(p => p.trim().toUpperCase())
      .filter(p => p.length > 0 && /\d/.test(p));

    if (primary && !orders.includes(primary)) {
      orders.unshift(primary);
    }

    if (!orders.length && primary) return primary;

    return orders.join(', ');
  };

  getOrderListFromRow = (row) => {
    const grouped = String(row?.erp_order_grouped || '').trim();
    const fallback = grouped || this.buildGroupedOrderString(row) || String(row?.erp_order_id || '').trim();

    if (!fallback) return [];

    const list = fallback
      .split(',')
      .map(s => s.trim().toUpperCase())
      .filter(Boolean);

    return Array.from(new Set(list));
  };

  getOrderCountFromRow = (row) => {
    return this.getOrderListFromRow(row).length || 0;
  };

  getTotalOrdersCount = (rows) => {
    return (rows || []).reduce((acc, r) => acc + this.getOrderCountFromRow(r), 0);
  };

  handleAgentChange = (selectedAgent) => {
    const filtered = this.state.checkinDetail.filter(
      d => d.usr_name_order_created === selectedAgent.value
    );
    this.setState({ selectedAgent, createdCount: filtered.length, filteredCheckins: filtered });
  };

  getAverageTime = (field) => {
    const { checkinDetail, selectedAgent } = this.state;

    const filtered = selectedAgent
      ? checkinDetail.filter(item => item.usr_name_order_created === selectedAgent.value)
      : checkinDetail;

    const validValues = filtered
      .map(item => item[field])
      .filter(val => val != null);

    if (validValues.length === 0) return '00:00:00';

    const totalSeconds = validValues.reduce((acc, time) => acc + this.toSeconds(time), 0);
    const avgSeconds = totalSeconds / validValues.length;
    return this.toTime(avgSeconds);
  };

  toSeconds = (timeString) => {
    const parts = timeString.split(':');
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const seconds = parseInt(parts[2], 10);
    return hours * 3600 + minutes * 60 + seconds;
  };

  getWebAndPisoCounts = () => {
    const items = this.state.checkinDetail || [];
    const web = items.filter(
      i => String(i.created_by_name || '').trim().toUpperCase() === 'PAGINA WEB'
    ).length;
    const piso = items.length - web;
    return { web, piso, total: items.length };
  };

  getCanceledCount = () => {
    const src = this.state.selectedAgent
      ? this.state.filteredCheckins
      : this.state.checkinDetail;

    return src.filter(i =>
      String(i.status || '').toLowerCase() === 'canceled' ||
      String(i.status || '').toLowerCase() === 'cancelled'
    ).length;
  };

  toTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return [hours, minutes, seconds]
      .map(val => val.toString().padStart(2, '0'))
      .join(':');
  };

  loadAgentOptions = (inputValue, callback) => {
    const options = this.props.catalog.agents
      .filter(agent => agent.departmentId === '006')
      .filter(agent => agent.name.toLowerCase().includes(inputValue.toLowerCase()))
      .map(agent => ({
        value: agent.name,
        label: agent.name,
      }));

    callback(options);
  };

  mountedTimer() {
    this.timerID = setInterval(
      async () => {
        if (this.props.isOpen) {
          await this.tick();
        }
      },
      this.state.updateMiliseconds
    );
  }

  async callDetail() {
    this.setState({ loading: true });

    try {
      const statusArray = await qad.catalog.website.getStatuses();
      let statuses = {};
      statusArray.forEach((status) => {
        statuses[status.status] = status.label;
      });
      this.setState({ statuses });

      let agentsByKey = {};
      this.props.catalog.agents.forEach((agent) => {
        if (!agentsByKey[agent.id]) {
          agentsByKey[agent.id] = agent;
        }
      });
  
      const { user } = this.props;
      console.log(user);
      const site = this.getSiteForUser();

      qad.catalog.website
        .getCheckins(this.state.dateSelect, this.state.dateEndSelect, site)
        .then((checkinDetail) => {
          const timeFields = [
            "arrive_at",
            "creating_order_at",
            "order_created_at",
            "paying_at",
            "transferencia_at",
            "payed_at",
            "order_received_at",
            "at_stock_at",
            "stocked_at",
            "at_deliver_at",
            "delivered_at",
            "canceled_at",
          ];

          checkinDetail.forEach((checkins) => {
            timeFields.forEach((field) => {
              const key = `time_${field}`;
              if (checkins[field]) {
                const date = new Date(checkins[field]);
                const hours = date.getHours().toString().padStart(2, "0");
                const minutes = date.getMinutes().toString().padStart(2, "0");
                const seconds = date.getSeconds().toString().padStart(2, "0");
                checkins[key] = `${hours}:${minutes}:${seconds}`;
              } else {
                checkins[key] = null;
              }
            });

            const diffMap = {
              diff_creating_order_at: ["arrive_at", "creating_order_at"],
              diff_order_created_at: ["creating_order_at", "order_created_at"],
              diff_paying_at: ["order_created_at", "paying_at"],
              diff_transferencia_at: ["paying_at", "transferencia_at"],

              diff_payment_time: ["paying_at", "order_received_at"],
              diff_order_received_delay: ["order_received_at", "payed_at"],

              diff_at_stock_at: ["payed_at", "at_stock_at"],
              diff_stocked_at: ["at_stock_at", "stocked_at"],
              diff_at_deliver_at: ["stocked_at", "at_deliver_at"],
              diff_delivered_at: ["at_deliver_at", "delivered_at"],
              diff_surtido_entregado: ["stocked_at", "delivered_at"],

              diff_sale_at: ["creating_order_at", "payed_at"],
              diff_payed_at: ["transferencia_at", "order_received_at"],
              diff_warehouse_at: ["order_received_at", "delivered_at"],
              diff_total_at: ["arrive_at", "delivered_at"],

              diffpaused_at: ["paused_at", "updated_at"],

              diff_payed_box: ["order_created_at", "order_received_at"],
              diff_empezo_surtir: ["payed_at", "stocked_at"],
              diff_lo_recibe_almacen: ["order_received_at", "payed_at"],
            };

            Object.entries(diffMap).forEach(([key, [startKey, endKey]]) => {
              const start = checkins[startKey] ? new Date(checkins[startKey]) : null;
              const end = checkins[endKey] ? new Date(checkins[endKey]) : null;

              if (
                start instanceof Date &&
                !isNaN(start) &&
                end instanceof Date &&
                !isNaN(end)
              ) {
                let diffMs = end - start;
                const hours = Math.floor(diffMs / 3600000).toString().padStart(2, "0");
                diffMs %= 3600000;
                const minutes = Math.floor(diffMs / 60000).toString().padStart(2, "0");
                diffMs %= 60000;
                const seconds = Math.floor(diffMs / 1000).toString().padStart(2, "0");
                checkins[key] = `${hours}:${minutes}:${seconds}`;
              } else {
                checkins[key] = null;
              }
            });

            if (checkins["paused_at"]) {
              const pausedStart = new Date(checkins["paused_at"]);
              const pausedEnd =
                checkins["status"] !== "paused" && checkins["updated_at"]
                  ? new Date(checkins["updated_at"])
                  : new Date();

              let diffMs = pausedEnd - pausedStart;
              const hours = Math.floor(diffMs / 3600000).toString().padStart(2, "0");
              diffMs %= 3600000;
              const minutes = Math.floor(diffMs / 60000).toString().padStart(2, "0");
              diffMs %= 60000;
              const seconds = Math.floor(diffMs / 1000).toString().padStart(2, "0");
              checkins["diffpaused_at"] = `${hours}:${minutes}:${seconds}`;
            } else {
              checkins["diffpaused_at"] = null;
            }

            Object.keys(statuses).forEach((status) => {
              const userId = checkins["usr_" + status];
              const rowName = checkins["usr_" + status + "_name"];
              checkins["usr_name_" + status] = rowName || (
                agentsByKey[userId]
                  ? agentsByKey[userId].name
                  : userId
              );
            });

            if (checkins["usr_delivered"]) {
              checkins["usr_name_delivered"] =
                checkins["usr_delivered_name"] ||
                (agentsByKey[checkins["usr_delivered"]]
                  ? agentsByKey[checkins["usr_delivered"]].name
                  : checkins["usr_delivered"]);
            }

            if (checkins["usr_transferencia"]) {
              checkins["usr_name_transferencia"] =
                checkins["usr_transferencia_name"] ||
                (agentsByKey[checkins["usr_transferencia"]]
                  ? agentsByKey[checkins["usr_transferencia"]].name
                  : checkins["usr_transferencia"]);
            }

            if (checkins["usr_paused"]) {
              checkins["usr_name_paused"] =
                checkins["usr_paused_name"] ||
                (agentsByKey[checkins["usr_paused"]]
                  ? agentsByKey[checkins["usr_paused"]].name
                  : checkins["usr_paused"]);
            }

            if (checkins["usr_canceled"]) {
              checkins["usr_name_canceled"] =
                checkins["usr_canceled_name"] ||
                (agentsByKey[checkins["usr_canceled"]]
                  ? agentsByKey[checkins["usr_canceled"]].name
                  : checkins["usr_canceled"]);
            } else if (checkins["usr_cancelled"]) {
              checkins["usr_name_canceled"] = agentsByKey[checkins["usr_cancelled"]]
                ? agentsByKey[checkins["usr_cancelled"]].name
                : checkins["usr_cancelled"];
            } else {
              checkins["usr_name_canceled"] = "";
            }
          });

          checkinDetail.forEach((checkins) => {
            checkins["diff_created_order"] = checkins["diff_order_created_at"] || null;
            checkins["created_by_name"] = checkins["usr_name_order_created"] || "";

            const grouped = this.buildGroupedOrderString(checkins);
            checkins.erp_order_grouped = grouped || (checkins.erp_order_id || "");
            checkins.erp_order_count = this.getOrderCountFromRow(checkins);
          });

          this.setState({ checkinDetail, loading: false });
        });
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
    }
  }

  DATE_FIELDS = ['arrive_at'];

  formatDateYYYYMMDD = (val) => {
    if (!val) return '';
    if (val instanceof Date) return val.toISOString().slice(0, 10);
    if (typeof val === 'string') return val.slice(0, 10);
    const d = new Date(val);
    return isNaN(d) ? '' : d.toISOString().slice(0, 10);
  };

  normalizeForExport = (rows) =>
    rows.map((item) => {
      const out = { ...item };
      this.DATE_FIELDS.forEach((f) => {
        if (out[f]) out[f] = this.formatDateYYYYMMDD(out[f]);
      });
      return out;
    });

  export = () => {
    const data = this.normalizeForExport(this.state.checkinDetail);
    this._export.save(data);
  };

  exportAlmacen = () => {
    if (this._exportAlmacen) {
      const almacenData = this.state.checkinDetail.filter(item =>
        ['stocked', 'at_stock', 'at_deliver', 'delivered', 'empacando', 'enviado', 'entregado'].includes(item.status)
      );

      if (almacenData.length === 0) {
        Swal.fire("Sin datos", "No hay turnos de almacén para exportar", "info");
        return;
      }

      const exportData = this.normalizeForExport(almacenData);
      this._exportAlmacen.save(exportData);
    }
  };

  exportPiso = () => {
    const source = this.state.selectedAgent
      ? this.state.filteredCheckins
      : this.state.checkinDetail;

    const exportData = this.normalizeForExport(source);
    this._exportPiso.save(exportData);
  };

  getSalesPersonIdUpper = () =>
    String(this.props?.user?.salesPersonId || '').trim().toUpperCase();

  canSeePisoReport = () => {
    const { user } = this.props;
    const spid = this.getSalesPersonIdUpper();
    return !!user && (user.departmentId === '006' || spid === 'VYAM' || spid === 'VRAT');
  };

  renderPisoTab() {
    const { user } = this.props;
    if (!this.canSeePisoReport()) return null;

    return (
      <Tab title="Reporte Piso">
        <Row style={{ alignItems: 'flex-end', marginBottom: '10px' }}>
          <Col s={2}>
            <h6>Fecha Inicio:</h6>
            <DatePicker
              options={{
                defaultDate: this.state.dateSelect,
                format: 'yyyy-mm-dd',
                onSelect: (date) => this.changedDate(date, this.state.dateEndSelect),
              }}
            />
          </Col>

          <Col s={2}>
            <h6>Fecha Fin:</h6>
            <DatePicker
              options={{
                defaultDate: this.state.dateEndSelect,
                format: 'yyyy-mm-dd',
                onSelect: (date) => this.changedDate(this.state.dateSelect, date),
              }}
            />
          </Col>

          <Col s={3}>
            <AsyncSelect
              cacheOptions
              loadOptions={this.loadAgentOptions}
              defaultOptions
              placeholder="Filtrar por Agente de Piso"
              onChange={this.handleAgentChange}
              value={this.state.selectedAgent}
              styles={{
                container: (provided) => ({
                  ...provided,
                  maxWidth: '300px',
                  minWidth: '250px',
                }),
              }}
            />
          </Col>

          <Col s={1}>
            <Button
              style={{ marginTop: '20px', backgroundColor: '#757575' }}
              onClick={this.clearAgentFilter}
            >
              Limpiar
            </Button>
          </Col>

          <Col s={4}>
            <div style={{ paddingLeft: '20px', fontSize: '14px' }}>
              <h6>Promedios</h6>
              {(() => {
  const { web, piso } = this.getWebAndPisoCounts();
  return (
    <ul style={{ margin: 0 }}>
{['VYAM', 'VRAT'].includes(String(user.salesPersonId || '').toUpperCase()) && (
  <li> <span role="img" aria-label="Tiempo">⏱️ </span>Promedio Atención Cliente: {this.getAverageTime("diff_creating_order_at")}</li>
)}
      <li><span role="img" aria-label="Promedio">⏱️ </span> Tiempo Creación Pedido Promedio: {this.getAverageTime("diff_created_order")}</li>
      <li><span role="img" aria-label="Agente">📦  </span>Pedidos creados por este agente: {(this.state.createdCount ?? 0)}</li>

      <li><span role="img" aria-label="PaginaWeb">🌐</span> Pedidos creados por PAGINA WEB: {web}</li>
      <li><span role="img" aria-label="Piso">🏬  </span>Pedidos creados en PISO: {piso}</li>
      <li><span role="img" aria-label="Cancelados">❌ </span>Pedidos cancelados: {this.getCanceledCount()}</li>
    </ul>
  );
})()}
            </div>
          </Col>
        </Row>

        <Row>
          <Col s={12}>
            <h6 style={{ marginTop: '10px' }}>
              Consultando del <strong>{this.state.dateSelect.toISOString().slice(0, 10)}</strong> al <strong>{this.state.dateEndSelect.toISOString().slice(0, 10)}</strong>
            </h6>
          </Col>
        </Row>

        {!this.state.loading ? (
          <ExcelExport
            ref={(exporter) => (this._exportPiso = exporter)}
            fileName={`ReportePiso_${this.state.dateSelect.toISOString().slice(0, 10)}_a_${this.state.dateEndSelect.toISOString().slice(0, 10)}.xlsx`}
          >
            <div style={{ marginBottom: '10px' }}>
              <Button onClick={this.exportPiso}>
                <span className="k-icon k-i-excel"></span> Exportar a Excel
              </Button>
            </div>

            <Grid
              data={
                this.state.selectedAgent
                  ? this.state.filteredCheckins
                  : this.state.checkinDetail
              }
            >
              <GridColumn field="turn" title="Turno" width="100px" />
              <GridColumn field="name" title="Cliente" width="200px" />
              <GridColumn field="erp_order_grouped" title="Pedido" width="250px" />
              <GridColumn field="quantity" title="Cantidad" width="100px" />
              <GridColumn field="status_label" title="Estado Final" width="200px" />
              <GridColumn field="usr_arrive_name" title="Registró Turno" width="200px" />

              <GridColumn field="cancel_comment" title="Razón de Cancelación" width="250px" />
              <GridColumn field="usr_name_canceled" title="Lo canceló" width="180px" />
              <GridColumn field="diff_created_order" title="Tiempo de Creación del Pedido" width="200px" />
              <GridColumn field="created_by_name" title="Le creó el Pedido" width="200px" />
              <GridColumn
                field="arrive_at"
                title="Fecha"
                width="180px"
                cell={(props) => (
                  <td>{props.dataItem[props.field]?.slice(0, 10) || ''}</td>
                )}
              />
            </Grid>
          </ExcelExport>
        ) : <LoadingView />}
      </Tab>
    );
  }

  getDate() {
    const today = this.state.dateSelect;
    return (today.getMonth() > 8 ? today.getMonth() + 1 : "0" + (today.getMonth() + 1)) + "-" + (today.getDate() > 9 ? today.getDate() : "0" + today.getDate());
  }

  changedDate(dateSelect, dateEndSelect) {
    this.setState({ dateSelect, dateEndSelect });
    this.callDetail();
  }

  render() {
    let agentsByKey = {};
    this.agents = this.props.catalog.agents.map((agent) => {
      if (!agentsByKey[agent.id]) {
        agentsByKey[agent.id] = agent;
      }
      return { value: agent.id, label: agent.name };
    });

    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.isOpen}
          onClose={this.handleCloseModal}
        >
          <Container className="remove-padding">
            <Row>
              <Col s={12}>
                <h3 className="m3">Reporte de turnos</h3>
                <Button onClick={() => this.tick()}> Actualizar Ahora</Button>

                <Tabs onChange={() => this.callDetail()}>
                  <Tab
                    options={{
                      duration: 300,
                      onShow: null,
                      responsiveThreshold: Infinity,
                      swipeable: false
                    }}
                    title="Reporte General"
                  >
                    <div className="separator" />
                    {
                      (!this.state.loading)
                        ? (
                          <Row>
                            {
                              Object.values(this.state.checkinsTotals).map((totals, index) => {
                                return (
                                  <Col key={index} s={12}>
                                    <Row>
                                      <Col s={12}>
                                        <h2>{totals["main_departament"]}</h2>
                                      </Col>
                                      {
                                        totals["statuses"].map((row, idx) => {
                                          return (
                                            <Col key={index + "_" + idx} s={3}>
                                              <div className="turn-waiting" style={{ backgroundColor: row["bgcolor_status"] }}>
                                                <div>
                                                  Turnos {row["label"]} en espera: {row["qty"]}
                                                </div>
                                              </div>
                                            </Col>
                                          );
                                        })
                                      }
                                    </Row>
                                  </Col>
                                );
                              })
                            }
                          </Row>
                        )
                        : <LoadingView />
                    }
                  </Tab>

                  <Tab
                    options={{
                      duration: 300,
                      swipeable: false
                    }}
                    title="Reporte Detalle"
                  >
                    <Row>
                      <Col>
                        <h5>Fecha Inicio:</h5>
                      </Col>
                      <Col>
                        <DatePicker
                          options={{
                            autoClose: true,
                            container: null,
                            defaultDate: this.state.dateSelect,
                            disableDayFn: null,
                            disableWeekends: false,
                            events: [],
                            firstDay: 0,
                            format: 'yyyy-mm-dd',
                            i18n: {
                              cancel: null,
                              clear: 'Clear',
                              done: null
                            },
                            onSelect: (date) => { this.changedDate(date, this.state.dateEndSelect); }
                          }}
                        />
                      </Col>
                      <Col>
                        <h5>Fecha Fin:</h5>
                      </Col>
                      <Col>
                        <DatePicker
                          options={{
                            autoClose: true,
                            container: null,
                            defaultDate: this.state.dateEndSelect,
                            disableDayFn: null,
                            disableWeekends: false,
                            events: [],
                            firstDay: 0,
                            format: 'yyyy-mm-dd',
                            i18n: {
                              cancel: null,
                              clear: 'Clear',
                              done: null
                            },
                            onSelect: (date) => { this.changedDate(this.state.dateSelect, date); }
                          }}
                        />
                      </Col>
                    </Row>

                    {
                      (!this.state.loading)
                        ? (
                          <ExcelExport ref={(exporter) => (this._export = exporter)} fileName={"ReporteTurnos_" + this.getDate() + ".xlsx"}>
                            <div style={{ marginBottom: '10px' }}>
                              <Button node="button" onClick={this.export}>
                                <span className="k-icon k-i-excel"></span> Exportar a Excel
                              </Button>
                            </div>

                            <Grid data={this.state.checkinDetail} fixedScroll={true}>
                              <GridColumn field="turn" title="Turno" width="100px" />
                              <GridColumn field="name" title="Cliente" width="250px" />
                              <GridColumn field="erp_order_grouped" title="Pedido" width="250px" />

                              <GridColumn
                                field="erp_order_count"
                                title={`Conteo de pedidos (${this.getTotalOrdersCount(this.state.checkinDetail)})`}
                                width="180px"
                                cell={(props) => <td style={{ textAlign: 'center', fontWeight: 700 }}>{props.dataItem.erp_order_count ?? 0}</td>}
                              />
                              <GridColumn field="quantity" title="Cantidad" width="100px" />
                              <GridColumn field="status_label" title="Estado Final" width="250px" />

                              <GridColumn field="time_arrive_at" title="Llegó" width="250px" />
                              <GridColumn field="usr_arrive_name" title="Registró Turno" width="180px" />

                              <GridColumn field="time_creating_order_at" title="Lo atendió piso" width="250px" />
                              <GridColumn field="time_order_created_at" title="Se creó el pedido" width="250px" />
                              <GridColumn field="time_paying_at" title="Lo atendió cajas" width="250px" />
                              <GridColumn field="time_transferencia_at" title="Se envió a Transferencia" width="250px" />
                              <GridColumn field="time_order_received_at" title="Finalizó el Pago" width="250px" />
                              <GridColumn field="payed_at_time" title="Lo Recibe Almacén" width="250px" />
                              <GridColumn field="time_at_stock_at" title="Se Empezó a surtir" width="250px" />
                              <GridColumn field="stocked_at_time" title="Se Surtió" width="250px" />

                              <GridColumn field="time_at_deliver_at" title="Se Empezó a Entregar" width="250px" />
                              <GridColumn field="time_delivered_at" title="Se Entregó" width="250px" />
                              <GridColumn field="time_canceled_at" title="Se Canceló" width="250px" />

                              <GridColumn field="diff_creating_order_at" title="Tiempo para atención de piso" width="250px" />
                              <GridColumn field="diff_order_created_at" title="Tiempo de creación del pedido" width="250px" />
                              <GridColumn field="diff_paying_at" title="Tiempo para atención en cajas" width="250px" />
                              <GridColumn field="diff_transferencia_at" title="Tiempo en Transferencia" width="250px" />
                              <GridColumn field="diff_payment_time" title="Tiempo de Pago" width="250px" />
                              <GridColumn field="diff_order_received_delay" title="Tiempo en Recibir pedido" width="250px" />
                              <GridColumn field="diff_at_stock_at" title="Tiempo para atención por Almacén" width="250px" />
                              <GridColumn field="diff_stocked_at" title="Tiempo para surtir" width="250px" />
                              <GridColumn field="diff_at_deliver_at" title="Tiempo para Entregar" width="250px" />
                              <GridColumn field="diff_delivered_at" title="Tiempo de entrega" width="250px" />
                              <GridColumn field="diff_sale_at" title="Tiempo en Piso" width="250px" />
                              <GridColumn field="diff_payed_at" title="Tiempo en Cajas" width="250px" />
                              <GridColumn field="diff_warehouse_at" title="Tiempo en Almacén" width="250px" />
                              <GridColumn field="diff_total_at" title="Tiempo en Tienda" width="250px" />

                              <GridColumn field="paused_comment" title="Motivo Pausa" width="250px" />
                              <GridColumn field="diffpaused_at" title="Tiempo Pausado" width="250px" />
                              <GridColumn field="usr_name_paused" title="Lo pausó" width="150px" />

                              <GridColumn field="usr_name_creating_order" title="Lo atendió" width="150px" />
                              <GridColumn field="usr_name_order_created" title="Le creó el pedido" width="150px" />
                              <GridColumn field="usr_name_paying" title="Le atendió en cajas" width="150px" />
                              <GridColumn field="usr_name_transferencia" title="Lo mandó a Transferencia" width="150px" />

                              <GridColumn field="usr_name_stocked" title="Lo atendió en Almacén" width="150px" />
                              <GridColumn field="usr_name_at_stock" title="Lo surtió" width="150px" />

                              <GridColumn field="usr_name_at_deliver" title="Asignó la Entrega" width="150px" />
                              <GridColumn field="usr_name_delivered" title="Lo Entregó" width="150px" />

                              <GridColumn field="cancel_comment" title="Razón de Cancelación" width="250px" />
                              <GridColumn field="arrive_at" title="Fecha" width="250px" cell={customDate} />
                            </Grid>
                          </ExcelExport>
                        )
                        : <LoadingView />
                    }
                  </Tab>

                  <Tab title="Reporte Almacén">
                    <Row style={{ alignItems: 'flex-end', marginBottom: '10px' }}>
                      <Col s={2}>
                        <h6>Fecha Inicio:</h6>
                        <DatePicker
                          options={{
                            defaultDate: this.state.dateSelect,
                            format: 'yyyy-mm-dd',
                            onSelect: (date) => this.changedDate(date, this.state.dateEndSelect),
                          }}
                        />
                      </Col>

                      <Col s={2}>
                        <h6>Fecha Fin:</h6>
                        <DatePicker
                          options={{
                            defaultDate: this.state.dateEndSelect,
                            format: 'yyyy-mm-dd',
                            onSelect: (date) => this.changedDate(this.state.dateSelect, date),
                          }}
                        />
                      </Col>

    {/* Promedios */}
    <Col s={8}>
      <div style={{ paddingLeft: '20px', fontSize: '14px' }}>
        <h6>Promedios</h6>
        <ul style={{ margin: 0 }}>
          <li> <span role="img" aria-label="Promedio">⏱️ </span> Tiempo Total Promedio: {this.getAverageTime("diff_total_at")}</li>
          <li> <span role="img" aria-label="Surtidor">📦</span> Recibe a Asignar Surtidor: {this.getAverageTime("diff_at_stock_at")}</li>
          <li><span role="img" aria-label="Surtidor">📦</span> Surtiendo / surtido: {this.getAverageTime("diff_stocked_at")}</li>
          <li><span role="img" aria-label="Entrega">🚚</span> Tiempo surtido a entrega: {this.getAverageTime("diff_surtido_entregado")}</li>
        </ul>
      </div>
    </Col>
  </Row>

                    <Row>
                      <Col s={12}>
                        <h6 style={{ marginTop: '10px' }}>
                          Consultando del <strong>{this.state.dateSelect.toISOString().slice(0, 10)}</strong> al <strong>{this.state.dateEndSelect.toISOString().slice(0, 10)}</strong>
                        </h6>
                      </Col>
                    </Row>

                    {
                      !this.state.loading ? (
                        <ExcelExport
                          ref={(exporter) => (this._exportAlmacen = exporter)}
                          fileName={`ReporteAlmacen_${this.state.dateSelect.toISOString().slice(0, 10)}_a_${this.state.dateEndSelect.toISOString().slice(0, 10)}.xlsx`}
                        >
                          <div style={{ marginBottom: '10px' }}>
                            <Button onClick={this.exportAlmacen}>
                              <span className="k-icon k-i-excel"></span> Exportar a Excel
                            </Button>
                          </div>

                          <Grid data={this.state.checkinDetail} fixedScroll={true}>
                            <GridColumn field="turn" title="Turno" width="100px" />
                            <GridColumn field="name" title="Cliente" width="200px" />
                            <GridColumn field="erp_order_grouped" title="Pedido" width="250px" />
                            <GridColumn
                              field="erp_order_count"
                              title={`Conteo de pedidos (${this.getTotalOrdersCount(this.state.checkinDetail)})`}
                              width="180px"
                              cell={(props) => <td style={{ textAlign: 'center', fontWeight: 700 }}>{props.dataItem.erp_order_count ?? 0}</td>}
                            />

                            <GridColumn field="quantity" title="Cantidad" width="100px" />
                            <GridColumn field="status_label" title="Estado Final" width="200px" />
                            <GridColumn field="diff_total_at" title="Tiempo Total" width="200px" />
                            <GridColumn field="diff_at_stock_at" title="Recibe / Asignar Surtidor" width="220px" />
                            <GridColumn field="diff_stocked_at" title="Surtiendo / Surtido" width="250px" />
                            <GridColumn field="diff_surtido_entregado" title="Surtido / Entregado" width="220px" />

                            <GridColumn field="usr_name_stocked" title="Lo atendió en Almacén" width="180px" />
                            <GridColumn field="usr_name_at_stock" title="Lo surtió" width="180px" />
                            <GridColumn field="usr_name_delivered" title="Lo entregó" width="180px" />

                            <GridColumn
                              field="arrive_at"
                              title="Fecha"
                              width="180px"
                              cell={(props) => (
                                <td>{props.dataItem[props.field]?.slice(0, 10) || ''}</td>
                              )}
                            />
                          </Grid>
                        </ExcelExport>
                      ) : <LoadingView />
                    }
                  </Tab>

                  {this.renderPisoTab() || <></>}
                </Tabs>
              </Col>
            </Row>
          </Container>
        </Modal>
      </React.Fragment>
    );
  }
}

class customDate extends React.Component {
  render() {
    if (this.props.dataItem[this.props.field] && this.props.dataItem[this.props.field] !== '') {
      return <td>{this.props.dataItem[this.props.field].slice(0, 10)}</td>;
    }
    return <td>{this.props.dataItem[this.props.field]}</td>;
  }
}

export { ModalCheckinRep as default };